import React from 'react';
import './DesktopFooter.css'; // Ensure this CSS file exists

const DesktopFooter = () => {
  return (
    <footer className="desktop-footer">
      <div className="desktop-footer-content">
        <ul className="desktop-footer-links">
          <li><a href="/new-home" className="desktop-footer-link">Home</a></li>
          <li><a href="/animehub" className="desktop-footer-link">Anime</a></li>
          <li><a href="/games" className="desktop-footer-link">Games</a></li>
          <li><a href="/new-blog-home" className="desktop-footer-link">Blog</a></li>

{/* <li><a href="/manga" className="desktop-footer-link">Manga</a></li> */}
{/* <li><a href="/community" className="desktop-footer-link">Community</a></li> */}
<li><a href="/profile" className="desktop-footer-link">Account</a></li>
        </ul>
        <div className="desktop-footer-info">
          <p>&copy; 2025 chibidash. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default DesktopFooter;  // Default export
